import { useEffect } from "react";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";
import getAppInfo from "src/utils/app-Info";

/**
 * IFC 환경에서 제공하지 않는 신청/계약 하위 화면(이용자 출입내역, 공용공간 이용시간 등)용 훅.
 * 링크로 직접 진입한 경우 신청/계약 상세로 리다이렉트하고, IFC 여부를 반환한다.
 * 반환값이 true 면 호출부에서 조회·렌더링을 건너뛴다.
 */
export function useIFCUnsupportedRedirect(contractId?: string) {
  const navigate = usePartnerNavigate();
  const isIFC = getAppInfo().appType === "IFC";

  useEffect(() => {
    if (!isIFC) {
      return;
    }

    navigate(contractId ? `/court/mypage/contracts/${contractId}` : "/court/mypage/contracts", { replace: true });
  }, [isIFC, contractId, navigate]);

  return isIFC;
}
